import { useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import dynamic from 'next/dynamic';

import TAGLink from '@/components/TAGLink';
import { useAppContext, useFacilityContext } from '@/context';
import { TAGBrand } from '@/types';
import { generateODPLinks } from '@/utils/generateODPLinks';

import { getNavItemStyles } from '../../NavigationBar/NavigationBarItem/NavigationBarItem.styles';

import { getLinkStyles, getNavMenuStyles } from './LocationNavMenu.styles';

const LovetLocationNavMenu = dynamic(() => import('@/snowflakes/lovet/Header/LocationNavMenu'));

interface IProps {
	isMobile?: boolean;
}

export default function LocationNavMenu({ isMobile }: Readonly<IProps>) {
	const { officeInfo } = useFacilityContext();
	const { config, theme } = useAppContext();

	const locationLinks = useMemo(() => (officeInfo ? generateODPLinks(officeInfo, config) : []), [officeInfo, config]);

	if (theme === TAGBrand.Lovet) {
		return <LovetLocationNavMenu isMobile={isMobile} />;
	}

	if (!officeInfo) return null;

	return (
		<Box sx={getNavMenuStyles(isMobile)}>
			{locationLinks.map((item) =>
				item ? (
					<TAGLink
						href={item.path}
						key={`location-navigation-link-${item.id}`}
						linkSx={{ ...(!isMobile && getNavItemStyles()), ...getLinkStyles(isMobile) }}
					>
						<Typography
							variant="bodyMediumSemiBold"
							color="text.interactive"
							data-testid={`link_location_${item.id}`}
						>
							{item.title}
						</Typography>
					</TAGLink>
				) : null
			)}
		</Box>
	);
}
